import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [1];
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push("start-ellipsis");

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < totalPages - 1) pages.push("end-ellipsis");

    pages.push(totalPages);
    return pages;
  };

  const pages = getVisiblePages();

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="h-10 px-4 rounded-full border border-gray-600 bg-gray-900 text-gray-200 text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-700"
      >
        Prev
      </button>

      {pages.map((page) =>
        typeof page === "string" ? (
          <span
            key={page}
            className="w-10 h-10 flex items-center justify-center text-gray-500"
          >
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? "page" : undefined}
            className={`w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-sm font-medium ${
              page === currentPage
                ? "bg-blue-500 text-white"
                : "bg-gray-800 text-gray-300 hover:bg-gray-600"
            }`}
          >
            {page}
          </button>
        ),
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="h-10 px-4 rounded-full border border-gray-600 bg-gray-900 text-gray-200 text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-700"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
